export const STC = 'stc/' as const
export const STC_ALL = `${STC}all` as const
export const STC_CATEGORY = `${STC}category/` as const
export const STC_CATEGORY_ALL = `${STC_CATEGORY}all` as const

export const STC_STEP = `${STC}step/` as const
export const STC_STEP_ALL = `${STC_STEP}all` as const
export const STC_STEP_COMPLETE = `${STC_STEP}complete` as const
